<template>
    <div>
    <h2> Quarantine Projects </h2>
    <h4> 5/19/2020 - <a href="http://kojichambers.com">kojichambers.com</a></h4>
    <div style="margin-top: -1em; margin-bottom: 1em;"> Cost: $12 | Made: $10</div>
      <div>
          My buddy Duncan recommended that I check out indiehackers.com, which I did,
          and I really enjoyed the bootstrap mentality on there and the discussion
          about how people reached various milestones. I've also been curious how
          much Amazon affiliate links bring in (I reckon less than 2.5%), so I
          thought of some things I know a lot about, and behold, kojichambers.com
          was an available domain. I whipped together a simple site with a parts
          list and the various gotchas someone might experience. I'm definitely
          curious to see how much reach r/koji and r/fermentation has, and if it ends
          up being a first page google result. The only cost so far is the domain
          name, which was $12 dollars.

      </div>
    </div>
</template>

<script>
export default {
    name: 'QuarantineProjects'
}
</script>
